// import React from 'react';
// import Slider from 'react-slick';
// import './Sliders.css';

// const Sliders = ({ designs }) => {
//   if (!Array.isArray(designs) || designs.length <= 0) {
//     return null;
//   }

//   const GalleryPrevArrow = ({ currentSlide, slideCount, ...props }) => {
//     const { className, onClick } = props;

//     return (
//       <div {...props} className="custom-prevArrow" onClick={onClick}>
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           viewBox="0 0 24 24"
//         >
//           <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
//         </svg>
//       </div>
//     );
//   };
//   const GalleryNextArrow = ({ currentSlide, slideCount, ...props }) => {
//     const { className, onClick } = props;

//     return (
//       <div {...props} className="custom-nextArrow" onClick={onClick}>
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           viewBox="0 0 24 24"
//         >
//           <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
//         </svg>
//       </div>
//     );
//   };

//   const settings = {
//     className: 'center',
//     centerMode: true,
//     focusOnSelect: true,
//     infinite: true,
//     centerPadding: '100px',
//     slidesToShow: 3,
//     speed: 500,
//     nextArrow: <GalleryNextArrow />,
//     prevArrow: <GalleryPrevArrow />
//   };

//   return (
//     <Slider {...settings}>
      // {designs.map((slide, index) => {
      //   return (
      //     <div key={index}>
      //       <img src={slide.image} alt="slider" key={index} className="image" />
      //     </div>
      //   );
      // })}
//     </Slider>
//   );
// };

// export default Sliders;

import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import styles from './Sliders.css';

// import './styles.css';

// import required modules
import { EffectCoverflow, Pagination } from 'swiper/modules';

const Sliders = ({ designs }) => {
  return (
    <>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        // pagination={true}
        modules={[EffectCoverflow, Pagination]}
        className={styles.mySwiper}
      >
        {designs.map((slide, index) => {
          return (
            <SwiperSlide key={index}>
              <img src={slide.image} alt="slider" key={index}  />
            </SwiperSlide>
          );
        })}
        {/* <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-1.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-2.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-7.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-8.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img src="https://swiperjs.com/demos/images/nature-9.jpg" />
        </SwiperSlide> */}
      </Swiper>
    </>
  );
}

export default Sliders;
